import { FC } from 'react';
import { useHistory } from 'react-router';
import { Box, Image, VStack } from '@chakra-ui/react';

import flyingBills from 'assets/brand/flying-bills@2x.png';
import { formatAmount } from 'common/formatAmount';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import { StepProps } from 'components/Stepper/types';
import useToast from 'components/ToastProvider/useToast';
import * as bankRoutes from 'features/Bank/routes';
import * as ContentLayout from 'layouts/ContentLayout';

import { useBulkTransferContext } from '../../context';
import locales from './locales';

const BulkTransfersCreationSuccess: FC<StepProps> = () => {
  const { sharedState } = useBulkTransferContext();
  const history = useHistory();
  const { showToast } = useToast();

  const onClickFinish = () => {
    showToast({ message: locales.toastMessage, type: 'success' });
    history.replace(bankRoutes.root);
  };

  return (
    <ContentLayout.Root>
      <ContentLayout.Body>
        <ContentLayout.BodyScrollableSection>
          <VStack
            alignSelf="center"
            spacing="space-32"
            textAlign="center"
            width="410px"
          >
            <VStack marginTop="space-40" spacing="space-24">
              <Box height="180px" width="180px">
                <Image alt="Success" boxSize="180px" src={flyingBills} />
              </Box>

              <Heading size="lg">{locales.title}</Heading>

              <VStack align="stretch" spacing="space-8">
                <Text>{locales.infoText}</Text>
                <Text>{locales.totalAmount}</Text>
              </VStack>

              <VStack
                alignSelf="stretch"
                backgroundColor="grey.200"
                borderRadius="radius-8"
                padding="space-16"
                spacing="space-8"
              >
                <Heading size="xl" variant="number">
                  {formatAmount({
                    currency: 'EUR',
                    type: 'payout',
                    value: sharedState.totalAmount,
                  })}
                </Heading>
              </VStack>
            </VStack>

            <Box width="310px">
              <Button onClick={onClickFinish} width="100%">
                {locales.ctaButton}
              </Button>
            </Box>
          </VStack>
        </ContentLayout.BodyScrollableSection>
      </ContentLayout.Body>
    </ContentLayout.Root>
  );
};

export default BulkTransfersCreationSuccess;
